<template>
  <div>
    <v-app-bar
      dense
      flat
      height="50"
    >
      <v-row align="center">
        <v-col
          xs="12"
          sm="5"
          md="4"
          class="d-none d-sm-flex"
        >
          <search-field
            :search-text="searchText"
            :status="status"
            @statusChange="changeStatus"
            @search="onSearch"
          />
        </v-col>
        <v-col
          xs="12"
          sm="7"
          md="8"
          align="end"
          class="d-sm-flex justify-end align-center"
        >
          <v-btn
            id="menu_item_refresh"
            color="primary"
            :loading="loader"
            class="mr-2 elevation-0"
            @click.native="reload()"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <register
            :show-dialog.sync="register"
            @refresh="reload"
          />
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                id="account_add"
                slot="activator"
                class="elevation-0"
                color="success"
                @click="newAccount()"
                v-on="on"
              >
                <v-icon>mdi-plus</v-icon> Account
              </v-btn>
            </template>
            <span>Register a new Evm account.</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-card
      flat
      outlined
      tile
    >
      <v-card-text>
        <v-row>
          <v-col
            xs="12"
            class="d-flex d-sm-none"
          >
            <search-field
              :search-text="searchText"
              :status="status"
              @statusChange="changeStatus"
              @search="onSearch"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            xs="12"
            class="pa-0"
          >
            <v-data-table
              :headers="headers"
              :items="accounts"
              :items-per-page="limit"
              :loading="loader"
              mobile-breakpoint="0"
              hide-default-footer
            >
              <template v-slot:[`item.id`]="{ item }">
                <v-icon x-small>
                  mdi-pound
                </v-icon>
                {{ item.id }}
              </template>
              <template v-slot:[`item.activeStatus`]="{ item }">
                <v-chip
                  label
                  :color="item.activeStatus ? 'success' : 'error'"
                  class="ma-1"
                >
                  {{ item.activeStatus ? "Active" : "In-active" }}
                </v-chip>
                <v-chip
                  v-if="item.active"
                  label
                  :color="item.active ? 'success' : 'error'"
                  class="ma-1"
                >
                  {{ item.active ? "Verified" : "Not verified" }}
                </v-chip>
              </template>
              <template v-slot:[`item.options`]="{ item }">
                <account-options
                  :account="item"
                  @reload="reload"
                />
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-show="totalPage > 1">
        <v-row>
          <v-col>
            <v-pagination
              v-model="page"
              :length="totalPage"
              :total-visible="7"
              @input="getAccounts()"
            />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
  
  <script>
  import { failure, pagination } from "@/mixins/common";
  import SearchField from "@/components/utils/SearchField";
  import Register from "./register.vue";
  import AccountOptions from "./AccountOptions.vue";
  
  export default {
      components: {
      SearchField,
      Register,
      AccountOptions
      // SearchById
      },
      mixins: [failure, pagination],
      data() {
          return {
              loader: false,
              accounts: [],
        sortKey: "name",
        searchKey: "name",
              searchText: null,
              register: false,
              page: 1,
              totalPage: 0,
        status: "",
        headers: [
        { text: "Id", value: "id", align: "start", sortable: false },
        { text: "Name", value: "name", align: "start", sortable: true },
        {
          text: "Status",
          value: "activeStatus",
          align: "center",
          sortable: false
        },
        { text: "", value: "options", align: "end", sortable: false }
      ]
          };
      },
      created() {
          this.init();
      },
      methods: {
          getAccounts() {
              this.loader = true;
              let url = `${this.EVM_API_URL}/accounts?page=${
                  this.page - 1
              }&search_key=${this.searchKey}&sort_key=${this.sortKey}&limit=${this.limit}&status=${this.status}`;
              if (this.searchText) {
                  url += `&search=${this.searchText}`;
              }
              this.$http.get(url).then(
                  (res) => {
                      this.accounts = res.body.data || [];
                      this.totalPage = res.body.totalPage;
                      this.page = res.body.pagination.page + 1;
                      this.loader = false;
                  },
                  (failure) => {
                      this.handleFailure(failure);
                  }
              );
          },
          search() {
              this.page = 1;
              this.getAccounts();
          },
          reload() {
              this.searchText = null;
             this.status = "";
              this.search();
          },
      onSearch(val) {
        this.searchText = val;
        if (!val || val.length >= 3) {
          this.search();
        }
      },
          changeStatus(status) {
              this.status = status;
              this.search();
          },
          newAccount() {
              this.register = true;
          },
          init() {
              this.getAccounts();
          },
          clear() {
              this.errors = {};
              this.$refs.form.reset();
          }
      }
  };
  </script>